import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  try {
    const a = JSON.parse(sessionStorage.getItem("daybreak-act-as") || "null");
    if (a?.uid) config.headers["X-Act-As"] = a.uid;
  } catch { /* ignore */ }
  return config;
});

api.interceptors.response.use(undefined, (e) => {
  if (e?.response?.data?.detail?.code === "wellbeing") window.dispatchEvent(new CustomEvent("daybreyk:wellbeing", { detail: e.response.data.detail.msg }));
  return Promise.reject(e);
});

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => (typeof d?.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  if (detail?.code === "wellbeing") return "Message not sent";
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
}
